import React, { Component } from "react";
import './Deal.css';
import Product from './Product';
import Clock from './Clock';
import AvTimerIcon from '@material-ui/icons/AvTimer';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';


class Deal extends Component {
    state={
        products:[
            {id:11,title:'title2',image:'assets/accessories.jpg',price:99.4,rating:3},
            {id:12,title:'title1',image:'assets/jeans.jpg',price:23.4,rating:4},
            {id:13,title:'title3',image:'assets/shoes.jpg',price:73.48,rating:2},
            {id:14,title:'title4',image:'assets/tops.png',price:53.4,rating:4},
            {id:15,title:'title5',image:'assets/soludos.jpg',price:443.4,rating:5},
            {id:16,title:'title6',image:'assets/soludos.jpg',price:443.4,rating:5},
        ],
    }
  render() {
   var settings = {  
      infinite: true,  
      speed: 600,  
      slidesToShow: 3,  
      slidesToScroll: 1 , 
      };
    return (
      <div className="deal my-3 ">
        <h2 className="deal__header">Deals of the Mounth <Clock/>  <AvTimerIcon/> </h2>
        <div className="deal__container">
           <Slider {...settings}> 
                  <div className="deal__item">
                       <Product className="item" products={this.state.products[0]}/>
                  </div>
                  <div className="deal__item">
                       <Product className="item" products={this.state.products[1]}/>
                  </div>
                  <div className="deal__item">
                       <Product className="item" products={this.state.products[2]}/>
                  </div>
                  <div className="deal__item">
                       <Product className="item" products={this.state.products[3]}/>
                  </div>
                  <div className="deal__item">
                       <Product className="item" products={this.state.products[4]}/>
                  </div>
                  <div className="deal__item">
                       <Product className="item" products={this.state.products[5]}/>
                  </div>
                 
                   
               </Slider> 
            </div>
        
      </div>
    );
  }
}

export default Deal;